<template>
  <!--section15-->
  <DsfSection
    mainWidth="1200px"
    :margin="[16, 0, 0, 0]"
    :padding="[0, 0, 0, 0]"
    :backgroundConfig="{
      color: 'transparent',
      image: '',
      size: 'cover',
      repeat: 'no-repeat',
      position: 'center',
    }"
    :foregroundConfig="{
      color: 'rgba(255, 255, 255, 0)',
      image: '',
      size: 'cover',
      repeat: 'no-repeat',
      position: 'center',
    }"
    v-if="data.bindAttr.model == 'login'"
  >
    <!--ncproductbanner77-->
    <div class="saas_banner_login_model">
      <div class="banner_model">
        <!--ncproductbanner77-->
        <DsfNcProductBanner
          ratio="165/68"
          :url="url"
          :showIndicators="data.bindAttr.model != 'horizontal' ? 'none' : 'inside'"
          :vertical="false"
          :indicatorWidth="16"
          :indicatorHeight="16"
          imageKeyName="banner"
          :bannerType="data.bindAttr.model"
          :unstatic="unstatic"
          borderRadius="16px"
        ></DsfNcProductBanner>
      </div>
      <div class="login_model">
        <loginModel boxWidth="100%" sourceUrl="/login/login" nameHolder="请输入账号" pwdHolder="请输入密码" codeHolder="动态验证码" :noTitle="false"></loginModel>
      </div>
    </div>
  </DsfSection>
  <DsfSection mainWidth="100%" :margin="[0, 0, 0, 0]" :padding="[0, 0, 0, 0]" :backgroundConfig="null" v-else>
    <!--ncproductbanner77-->
    <DsfNcProductBanner
      ratio="19/6"
      :url="url"
      :showIndicators="data.bindAttr.model != 'horizontal' ? 'none' : 'inside'"
      :vertical="data.bindAttr.model != 'horizontal'"
      :indicatorWidth="16"
      :indicatorHeight="16"
      imageKeyName="banner"
      :bannerType="data.bindAttr.model"
      :unstatic="unstatic"
    ></DsfNcProductBanner>
  </DsfSection>
</template>
<script>
import loginModel from "./loginModel.vue";
export default {
  ctrlCaption: "轮播图",
  name: "DsfNcSaasHomeBannerNew",
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    unstatic: {
      type: Boolean,
      default: true,
    },
    url: {
      type: String,
      default: "/nc/banner/info/pclist?code=001&pageSize=6",
    },
    // 配置字段名
    imageKeyName: {
      type: String,
      default: "image",
    },
    titleKeyName: {
      type: String,
      default: "title",
    },
    descKeyName: {
      type: String,
      default: "desc",
    },
    jumpWayKeyName: {
      type: String,
      default: "jumpWay",
    },
  },
  data() {
    return {
      noImgUrl: "",
    };
  },
  components:{
    loginModel,
  },
  watch: {},
  computed: {},
  mounted() {
    this.noImgUrl = dsf.config.setting_nc_image_banner_img || dsf.config.setting_nc_image_default_img || "";
  },
  methods: {},
};
</script>
